import {navigationElementId} from '../details.config';
import {searchWidgetId} from '../../../utils/common-utils';

export const getStickyOffsetY = () => {
  const searchWidgetHeight = document.getElementById(searchWidgetId)?.offsetHeight;
  const navigationHeaderHeight = document.getElementById(navigationElementId)?.offsetHeight;

  // write detailed comment here about what is happening
  const stickyOffsetY =
    searchWidgetHeight && navigationHeaderHeight
      ? searchWidgetHeight + navigationHeaderHeight
      : 149; // this is a manually calculated safe magic number, leave it be

  return stickyOffsetY;
};

export default getStickyOffsetY;
